/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React, { useState, useEffect } from "react";
import Button from "Admin/elements/CustomButton/CustomButton.jsx";
import { Modal } from "react-bootstrap";
import Select from "react-select";

const visitTypeOptions = [
    { label: "New", value: "register" },
    { label: "FollowUp", value: "followup" },
    { label: "Reported", value: "reported" }
];

const OtherFilterModal = ({ showModal, handleClose, treatments, filters }) => {
    const [selectedFilters, setSelectedFilters] = useState([]);
    const [visitType, setVisitType] = useState([]);
    const [selectedTreatment, setSelectedTreatment] = useState([]);

    const handleVisitType = (options) => {
        const updatedFilters = selectedFilters.filter((obj) => obj.filter !== "visitType");

        options.forEach((opt) => {
            updatedFilters.push({ filter: "visitType", value: opt.value });
        });

        setSelectedFilters(updatedFilters);
    };

    const handleTreatment = (options) => {
        console.log(options, "ooooooo")
        const updatedFilters = selectedFilters.filter((obj) => obj.filter !== "treatment");

        options.forEach((opt) => {
            updatedFilters.push({ ...opt, filter: "treatment", value: opt.value });
        });

        setSelectedFilters(updatedFilters);
    };

    const removeFilter = (filter, valueToRemove) => {
        const updatedFilters = selectedFilters.filter((obj) => obj.filter !== filter && obj.value !== valueToRemove);
        setSelectedFilters(updatedFilters)

        switch (filter) {
            case "treatment":
                setSelectedTreatment(selectedTreatment.filter(g => g.value !== valueToRemove));
                break;
            case "visitType":
                setVisitType(visitType.filter(pt => pt.value !== valueToRemove));
                break;
            default:
                break;
        }
    };

    function generateId() {
        let id = "";
        let characters =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (let i = 0; i < 8; i++) {
            id += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return id;
    }

    const handleSaveModal = () => {
        const updatedFilters = selectedFilters.map((ele) => ({ ...ele, category: "Other", id: generateId() }))
        handleClose(updatedFilters)
    }

    useEffect(() => {
        if (filters) {
            const cloneSelectedTreatment = selectedTreatment
            const cloneVisitType = visitType
            filters.map((ele) => {
                const { filter, value } = ele
                switch (filter) {

                    case "treatment":
                        {
                            cloneSelectedTreatment.push({ ...ele, label: value, value: value })
                            break;
                        }
                    case "visitType":
                        {
                            cloneVisitType.push({ label: value, value: value })
                            break;
                        }
                    default:
                        break;
                }
            })
            setSelectedTreatment(cloneSelectedTreatment)
            setVisitType(cloneVisitType)
            setSelectedFilters(filters)
        }
    }, [])

    return (
        <>
            <Modal
                show={showModal}
                onHide={handleClose}
                dialogClassName="modal-lg"
            >
                <Modal.Header closeButton className="bg-thumbcolor">
                    <Modal.Title id="example-modal-sizes-title-lg">
                        Other Filters
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="suggetion-box-enlarge">
                    <div className="filter-box-container">
                        <div className="row">
                            <div className="col-md-6">
                                <label>Visit Type</label>
                                <Select
                                    options={visitTypeOptions}
                                    multi={true}
                                    value={visitType}
                                    onChange={(selected) => {
                                        setVisitType(selected || [])
                                        handleVisitType(selected);
                                    }
                                    }
                                />
                            </div>
                            <div className="col-md-6">
                                <label>Diet</label>
                                <Select
                                    options={treatments}
                                    multi={true}
                                    value={selectedTreatment}
                                    onChange={(selected) => {
                                        setSelectedTreatment(selected || [])
                                        handleTreatment(selected);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="selected-filters d-flex self-flex-wrap col-gap-5 ">
                            {selectedFilters.map((obj, index) => (
                                <span key={index} className="filter-badge">
                                    {obj?.filter}: {obj?.value}
                                    <span className="remove-filter" onClick={() => removeFilter(obj?.filter, obj?.value)}> × </span>
                                </span>
                            ))}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleSaveModal}>Save</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default OtherFilterModal